import { COMPANY_NAME, SITE_NAME, SITE_URL } from './site';

export const THEME_COLOR = '#12324f';

export const DEFAULT_PAGE_META = {
  title: `${SITE_NAME} | Independent Travel Agency for Flights, Hotels & Cruises`,
  description: `${SITE_NAME} is an independent travel agency run by ${COMPANY_NAME}. Our advisors help you plan and book flights, hotels, rental cars, cruises and vacation packages, with every fee shown before you pay.`,
  url: `${SITE_URL}/`,
  themeColor: THEME_COLOR,
};

export const FLIGHT_PAGE_META = {
  title: `${SITE_NAME} | Travel Search`,
  description: `Explore flight, hotel, car, cruise and package options with ${SITE_NAME}, an independent travel agency run by ${COMPANY_NAME}.`,
  url: `${SITE_URL}/flight`,
  themeColor: THEME_COLOR,
};

/** Meta for a standalone page such as /privacy-policy */
export const pageMeta = (title, description, path) => ({
  title: `${title} | ${SITE_NAME}`,
  description,
  url: `${SITE_URL}${path}`,
  themeColor: THEME_COLOR,
});
